import { Link } from 'react-router-dom';
import { footerQuickLinks, footerSupportLinks, footerAboutLinks } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
                  17
                </div>
                <span className="font-heading font-bold text-xl text-background-50">17c 平台</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                http //www.17c/ 官方入口与使用指南，为您提供完整的平台访问指引与功能介绍，助您高效使用 17c 平台各项服务。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 mb-4">
                <a href="/category/guide" className="hover:text-primary-400 transition-colors cursor-pointer">快速导航</a>
              </h4>
              <ul className="space-y-2.5">
                {footerQuickLinks.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 mb-4">
                <a href="/category/faq" className="hover:text-primary-400 transition-colors cursor-pointer">帮助支持</a>
              </h4>
              <ul className="space-y-2.5">
                {footerSupportLinks.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-100 mb-4">
                <a href="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                {footerAboutLinks.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2021-2026 17c 平台 版权所有 | http //www.17c/ 官方入口
            </p>
            <div className="flex items-center gap-4">
              <Link to="/article/privacy" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                隐私政策
              </Link>
              <Link to="/article/terms" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                用户协议
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}